<template>
    <div class="tabs_content" id="tab-2" v-if="entity">
        <section>
            <a v-if="isEditable" @click="_addProtocol" class="tab_button tab_button_add" :title="$gettext('Přidat protokol')" v-translate>Přidat protokol</a>

            <h2 v-if="noSettings" v-translate>Nastavení není definováno.</h2>

            <PopupWithSelectbox
                @submitAction="_onPopupWithSelectActionSubmited"
            />

            <StreamProfileOrder v-for="(protocolSettings, idProtocol) in entity.protocols"
                :entity="entity"
                :id-protocol="idProtocol"
                :protocolSettings="protocolSettings"
                :protocols.sync="protocols"
                :stream-profiles.sync="streamProfiles"
                :isEditable="isEditable"
                @removeProtocol="onRemoveProtocol"
                @removeStreamProfile="onRemoveStreamProfile"
                @addStreamProfile="onAddStreamProfile"
                @sortStreamProfile="onSortStreamProfile"
                :key="'protocol' + idProtocol"
            />

        </section>
    </div>
</template>

<script>

import StreamProfileOrder from "./StreamProfileOrder";
import PopupWithSelectbox from "../../../common/PopupWithSelectbox";
import popupWithSelectboxMixin from "@/components/mixins/popup-with-selectbox"

export default {
    name: "ProtocolSettings",
    props: {
        entity: Object,
        streamProfiles: Array,
        protocols: Array,
        isEditable: Boolean
    },
    mixins: [popupWithSelectboxMixin],
    components: {PopupWithSelectbox, StreamProfileOrder},
    methods: {
        _processDetailErrorMessage(error) {
            return this.processErrorMessage(error)
        },
        onRemoveProtocol(idProtocol) {
            if (this.entity.protocol_order_linear_content.includes(~~idProtocol) || this.entity.protocol_order_nonlinear_content.includes(~~idProtocol)) {
            } else {
                delete this.entity['protocols'][idProtocol];
                this.entity['protocols'] = {...this.entity['protocols']};
            }
        },
        onRemoveStreamProfile(idProtocol, deletedIdStreamProfile) {
            this.entity['protocols'][idProtocol]['stream_profile_order'] = this.entity['protocols'][idProtocol]['stream_profile_order'].filter((idStreamProfile) => idStreamProfile != deletedIdStreamProfile);
        },
        onAddStreamProfile(idProtocol, newIdStreamProfile) {
            this.entity['protocols'][idProtocol]['stream_profile_order'] = [...this.entity['protocols'][idProtocol]['stream_profile_order'], newIdStreamProfile];
        },
        onSortStreamProfile(idProtocol, newStreamProfileSortedIds) {
            this.entity['protocols'][idProtocol]['stream_profile_order'] = newStreamProfileSortedIds;
        },
        _addProtocol() {
            const usedProtocolIds = Object.keys(this.entity.protocols).map(function(item) {
                return parseInt(item, 10);
            });

            const availableProtocols = this.protocols.filter((protocol) => {
                return !usedProtocolIds.includes(protocol.id);
            });

            this.showPopupWithSelectbox("add-protocol", this.$gettext("Vyberte protokol:"), this.$gettext("Přidat protokol"), availableProtocols);
        },
        _onPopupWithSelectActionSubmited(action, selectedValue, data) {
            if (action === "add-protocol") {
                this._onProtocolAdded(selectedValue);
            }
        },
        _onProtocolAdded(idProtocol) {
            const newProtocols = {...this.entity.protocols};
            newProtocols[idProtocol] = {
                stream_profile_order: [],
                adaptivity_order: [true]
            };

            this.entity.protocols = newProtocols;
        }
    },
    computed: {
        noSettings() {
            let settingsNotDefined = true;

            try {
                settingsNotDefined = Object.keys(this.entity.protocols).length === 0;
            } catch (e) {
            }

            return settingsNotDefined;
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/views/deviceProfiles/forms/ProtocolSettings.vue